/**
 * RankingCamposTable (M10, RF-M10-003) — tabela do top-N de campos mais
 * corrigidos (contagem sobre a tabela `edicao` do M8). Sem dado pessoal — só
 * nome do campo e contagem (RN-GLOBAL-004).
 */

import { CampoCorrigido } from '../services/painel-types';

export interface RankingCamposTableProps {
  readonly campos: readonly CampoCorrigido[];
}

export function RankingCamposTable({ campos }: RankingCamposTableProps): JSX.Element {
  if (campos.length === 0) {
    return <p className="muted">Nenhuma correção registrada ainda.</p>;
  }
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Campo</th>
          <th>Correções</th>
        </tr>
      </thead>
      <tbody>
        {campos.map((c) => (
          <tr key={c.campo}>
            <td>{c.campo}</td>
            <td>{new Intl.NumberFormat('pt-BR').format(c.edicoes)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
